import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { IssueTableSkeleton } from '@jira/issue-table__issue-table/src/common/ui/skeleton/index.tsx';
import { plannerIssueListEmbedRoute } from '@jira/router-routes__planner-issue-list-embed-routes/src/plannerIssueListEmbedRoute.tsx';
import { plannerIssueListEmbedEntryPoint } from '@jira/ai-planning__planner-issue-list-embed/src/plannerIssueListEmbedEntryPoint.entrypoint.tsx';
import { themePreferenceResource } from '@jira/router-resources__theme-preference/src/useThemePreference.tsx';
import type { Route } from '@atlassian/react-resource-router';

const plannerIssueListEmbedPageEntryPoint = createChromelessEntryPoint({
	main: plannerIssueListEmbedEntryPoint,
});

export const plannerIssueListEmbedRouteEntry: Route = createEntry(
	plannerIssueListEmbedRoute,
	() => ({
		group: 'planner',
		ufoName: 'planner-issue-list-embed',
		apdexIgnoreParams: ['jql', 'themeMode'],
		layout: chromelessLayout,
		skeleton: IssueTableSkeleton,
		// Registers the theme-preference resource so the shell's GlobalThemeSetter applies a theme
		// for this chromeless embed — including honoring the `themeMode` query param (light|dark) AI
		// Planner passes (see getThemeOverrideFromQueryParameters) and stamping `data-color-mode`
		// during SSR for a flash-free first paint. Without this the resource never runs and the iframe
		// falls back to the default theme regardless of the host's theme.
		resources: [themePreferenceResource],
		meta: {
			reporting: {
				id: 'planner-issue-list-embed',
				packageName: 'jiraPlannerIssueListEmbed',
				teamName: 'Dev AI - Planner',
			},
		},
		entryPoint: () => plannerIssueListEmbedPageEntryPoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
